module.exports = __webpack_public_path__ + "img/pic7.1e0de40c.png";